import Page from '@acri-tools/react-tools/components/Page/Page';
import { LoginState } from '@acri-tools/react-tools/redux/reducers/loginReducer';
import { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { get_page_title } from '../../utils/config';

interface Props {
    // redux
    login?: LoginState
}
interface State {
}

class Ftp extends Component<Props, State> {
    getDownloadURL() {
        const username = this.props.login?.user?.username
        // This must always call the root of the download otherwise the still will not load
        return "ftp/users/" + username + "/"
    }
    render() {
        return (
            <Page
                id="ftp"
                banner={{
                    title: "FTP",
                    topBar: true
                }}
                footer
            >
                <Helmet>
                    <title>{get_page_title('DAMPS - FTP server')}</title>
                    <meta
                        name="description"
                        content="How to acess the DAMPS FTP server"
                    />
                </Helmet>
                <iframe width="100%" height="400px" src={this.getDownloadURL()}></iframe>
            </Page>
        );
    }

};

export default connect((state: any) => {
    return {
        login: state.login
    }
})(Ftp);
